import './card-class-branch.scss';
import { useEffect, useState } from 'react';
import format from 'date-fns/format';
import Grid from '@mui/material/Grid';
import TakeAttendanceByOne from '../take-attendance-by-one/take-attendance-by-one';

import { ModalCancelClass } from '../modal-cancel-class/modal-cancel-class';
import { ModalOpenClass } from '../modal-open-class/modal-open-class';
import { ModalRequestQuotas } from '../modal-request-quotas/modal-request-quotas';

import { ADD_CLOSE_QUOTAS, CLASSES_BRANCH } from '../../graphql/branch';
import { useMutation } from '@apollo/client';

import Button from '@mui/material/Button';
import { Box, FilledInput, InputAdornment } from '@mui/material';
import { Add, Remove } from "@mui/icons-material";
import Icon from '../icon/icon';
import React from 'react';
import ModalEditClass from './modal-edit/modal-edit';

export const CardClassBranch = ({ cardData, zoomResponse, checkBooks, updateData,edit }: { zoomResponse: (e: any, flag: any) => void, cardData: any, checkBooks: () => void, updateData: () => void, edit:boolean }) => {
    const [isOpen, setIsOpen] = useState(false);

    const [isModalEditClass, setIsModalEditClass] = useState(false);

    const handleToggleEditClassModal = () => {
        setIsModalEditClass(prevIsModalEditClassOpen => !prevIsModalEditClassOpen);
      };

    const handleToggleModal = () => {
        setIsOpen(prevIsOpen => !prevIsOpen);
    };
    // let [availableSpacesTextValue] = useState<number>(cardData.availableSpace ?? 0);
    // const onAvailableSpacesChange = (e: any) => availableSpacesTextValue = parseInt(e.target.value);
    const [ActiveQuotas, { loading }] = useMutation(ADD_CLOSE_QUOTAS, {
        refetchQueries: [CLASSES_BRANCH]
    });

    let image: string;
    if (cardData.classFit.teacher && cardData.classFit.teacher.image_teacher) {
        image = cardData.classFit.teacher.image_teacher;
    } else if (cardData.classFit.url_image) {
        image = cardData.classFit.url_image;
    } else {
        image = cardData.classFit.fitType.imageUrlClassType;
    }

    const openLink = (data: any) => {
        zoomResponse(data, cardData.classFit.branch.host_admin);
    }

   


    function changeAvailableSpaces(action: string) {
        let newAvailableSpacesTextValue = 1;

        ActiveQuotas({
            variables: {
                userId: null,
                calendarId: cardData.id,
                close: action === 'remove' ? true : false,
                quotas: newAvailableSpacesTextValue,
                type: action
            },
        })
    }

    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    // function handleClick(){
    //     setIsModalEditClass(prevIsModalEditClassOpen => !prevIsModalEditClassOpen);
    // }

    return (  
        <div className={`card  ${(cardData.capacity - cardData.availableSpace > 0 && cardData.enabled) ? ' reservation-active' : ''}`} >

              { !edit &&(

                  <Grid container>

                <Grid item xs={8}>
                    <Grid container className={`container-class ${!cardData.enabled ? ' disabled-class' : ''}`}>
                        <Grid item xs={3}>
                            <div className='contain-img'>
                                <img src={image} alt='fitpal' className='img-card-branch' />
                                {(cardData.virtualClass && cardData.virtualClass.zoom_link) && cardData.enabled &&
                                    <Button onClick={(e) => openLink(cardData.virtualClass)} className="chip">
                                        Ingresar a la clase
                                    </Button>
                                }
                            </div>
                        </Grid>
                        <Grid item xs={9} display={'flex'}>
                            <Grid container>
                                <Grid item xs={5} className='container-info-mobile'>
                                    <div className={`box-info  ${!cardData.enabled ? 'vertical-center' : ''}`}>
                                        <h4 className='title'>{cardData.classFit.name}</h4>
                                        <h4 className='subtitle'>{format(new Date(cardData.start), 'HH:mm')}</h4>
                                        {cardData.classFit.virtual && (
                                            <h5 className='subtitle'>Virtual</h5>
                                        )}
                                    </div>

                                    {/* Mobile */}
                                    <div className="title-mobile" style={{ display: 'none' }}>
                                        {((cardData.lateCancel === 1 && cardData.hasReservationCancel === 1) && !cardData.enabled && !cardData.cancelClass) && (
                                            <div className='penalty-class ml-1'>
                                                Penalización: ${cardData.studio?.lateFee ?? '0'}
                                            </div>
                                        )}
                                        {!cardData.enabled && cardData.cancelClass && (
                                            <div className='penalty-class ml-1'>
                                                Pendiente
                                            </div>
                                        )}
                                        {((!cardData.enabled) && (cardData.lateCancel !== 1 || cardData.hasReservationCancel !== 1)) && (
                                            <div className='penalty-class'>
                                                Cancelada
                                            </div>
                                        )}
                                        {cardData.enabled && (
                                            <>
                                                <FilledInput
                                                    className='input-space' readOnly
                                                    value={cardData.availableSpace ? cardData.availableSpace : 0}
                                                    // onChange={(ev) => onAvailableSpacesChange(ev)}
                                                    endAdornment={<InputAdornment position="end">Cupos</InputAdornment>}
                                                />
                                                <Box className='ml-05'>
                                                    <Button className='btn-space mt-0'
                                                        disabled={loading || !cardData.availableSpace ? true : false}
                                                        onClick={() => { changeAvailableSpaces('remove') }}>
                                                        <Remove fontSize="small" />
                                                    </Button>
                                                    <Button className='btn-space mt-0'
                                                        disabled={loading || cardData.availableSpace >= 5 ? true : false || !cardData.availableSpace ? true : false}
                                                        onClick={() => { changeAvailableSpaces('add') }}>
                                                        <Add fontSize="small" />
                                                    </Button>
                                                </Box>
                                            </>
                                        )}
                                    </div>


                                </Grid>

                                <Grid item xs={7} className='container-space'>
                                    {cardData.enabled && (
                                        <React.Fragment>
                                            <Box>
                                                <FilledInput
                                                    className='input-space' readOnly
                                                    value={cardData.availableSpace ? cardData.availableSpace : 0}
                                                    // onChange={(ev) => onAvailableSpacesChange(ev)}
                                                    endAdornment={<InputAdornment position="end">Cupos</InputAdornment>}
                                                />
                                            </Box>
                                            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }} className='group-btn-space'>
                                                <Box>
                                                    <Button className='btn-space'
                                                        disabled={loading || !cardData.availableSpace ? true : false}
                                                        onClick={() => { changeAvailableSpaces('remove') }}>
                                                        <Remove fontSize="small" />
                                                    </Button>
                                                    <Button className='btn-space'
                                                        disabled={loading || cardData.availableSpace >= 5 ? true : false || !cardData.availableSpace ? true : false}
                                                        onClick={() => { changeAvailableSpaces('add') }}>
                                                        <Add fontSize="small" />
                                                    </Button>
                                                </Box>
                                            </Box>
                                        </React.Fragment>
                                    )}
                                    {((cardData.lateCancel === 1 && cardData.hasReservationCancel === 1) && !cardData.enabled && !cardData.cancelClass) && (
                                        <div className='penalty-class'>
                                            Penalización: ${cardData.studio?.lateFee ?? '0'}
                                        </div>
                                    )}
                                    {!cardData.enabled && cardData.cancelClass && (
                                        <div className='penalty-class'>
                                            Pendiente
                                        </div>
                                    )}
                                    {((!cardData.enabled) && (cardData.lateCancel !== 1 || cardData.hasReservationCancel !== 1)) && (
                                        <div className='penalty-class'>
                                            Cancelada
                                        </div>
                                    )}
                                </Grid>

                                {cardData.enabled && (
                                    <ModalRequestQuotas calendarId={cardData.id} availableSpace={cardData.availableSpace ?? 0} isRequestQuota={cardData.requestQuota}></ModalRequestQuotas>
                                )}
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={4} display={'grid'} className='box-info-reservation'>

                    <div className='contain-quotas quotas-info-desktop'>
                        <h4 className='subtitle2'>
                            <Box sx={{ display: 'inline-flex', color: !cardData.enabled && cardData.capacity - cardData.availableSpace !== 0 ? '#FF0000' : cardData.capacity - cardData.availableSpace === 0 ? '#747474' : '#06BAA6', fontWeight: cardData.capacity - cardData.availableSpace === 0 ? 'normal' : 'bold', }}>
                                <Icon name='user-check' width='25' height='25' color={!cardData.enabled && cardData.capacity - cardData.availableSpace !== 0 ? '#FF0000' : cardData.capacity - cardData.availableSpace === 0 ? '#747474' : '#06BAA6'} />
                                <span className='ml-05'>
                                    {cardData.capacity - cardData.availableSpace}{" "}{cardData.capacity - cardData.availableSpace === 1 ? "reserva" : "reservas"}
                                </span>
                            </Box>
                        </h4>
                    </div>
                    <div className='btns-classes'>
                        {cardData.enabled && (
                            <>
                                <Button key={cardData.id} onClick={handleToggleModal} className={`btn-take-attendance ${windowWidth <= 860 ? ' btn-action-mobile' : ''}`}
                                    //TODO
                                    disabled={cardData.reservations?.length === 0 || cardData.reservations?.every((reservation: any) => reservation.statusId === 6)}>
                                    {windowWidth >= 861 && (<span>Tomar asistencia</span>)}
                                    {windowWidth <= 860 && (<Icon width='20' height='19' name='checklist'></Icon>)}
                                </Button>
                                {isOpen && (<TakeAttendanceByOne calendarId={cardData.id} isOpenModal={isOpen} setIsOpen={setIsOpen} />)}
                            </>
                        )}

                        {cardData.availableSpace && cardData.enabled &&
                            <ModalCancelClass calendarId={cardData.id} feeLate={cardData?.studio?.lateFee} availableSpace={cardData.availableSpace ?? 0} reservations={cardData.capacity - cardData.availableSpace} lateCancel={Date.now() > (new Date(cardData.start).getTime() - 6 * 60 * 60 * 1000) ? true : false} />
                        }
                        {!cardData.enabled && windowWidth >= 861 && (
                            <ModalOpenClass calendarId={cardData.id} availableSpace={cardData.availableSpace ?? 0} />
                        )}
                    </div>

                    <div className='btns-classes' style={{ position: 'inherit', display: 'block' }}>
                        {!cardData.enabled && windowWidth <= 860 && (
                            <ModalOpenClass calendarId={cardData.id} availableSpace={cardData.availableSpace ?? 0} />
                        )}
                    </div>

                </Grid>
            </Grid>
            )}

{edit && (
    
        <Grid container>
          <Grid item xs={8}>
            <Grid container className={`container-class ${!cardData.enabled ? ' disabled-class' : ''}`}>
              <Grid item xs={3}>
                <div className='contain-img'>
                  <img src={image} alt='fitpal' className='img-card-branch' />
                </div>
              </Grid>

              <Grid item xs={9} display={'flex'}>
                <Grid container>
                  <Grid item xs={12} display={'flex'}>
                    <div className={`box-info-edit`}>
                      <h4 className='title'>Nombre de la clase</h4>
                      <h4 className='subtitle'>{cardData.classFit.name}</h4>
                    </div>
                    <div className={`box-info-edit`}>
                      <h4 className='title'>Hora</h4>
                      <span className='subtitle'>{format(new Date(cardData.start), 'HH:mm')}</span>
                    </div>
                    <div className={`box-info-edit`}>
                      <h4 className='title'>Cupos</h4>
                      <span className='subtitle'>{cardData.availableSpace ? cardData.availableSpace : 0}</span>
                    </div>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={4} display={'grid'} className='box-info-reservation'>
            <div className='btns-edit-classes'>
              {cardData.enabled && (
                <Button onClick={handleToggleEditClassModal} key={cardData.id} className={`btn-edit-attendance`}>
                  <span>Editar Clase</span>
                </Button>
              )}
            </div>
          </Grid>

          <ModalEditClass open={isModalEditClass} handleClose={handleToggleEditClassModal} updateData={updateData} data={cardData} />
        </Grid>
      )}
        </div>
    );
}